import * as yup from 'yup';

const hourRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
const dateRegex = /(^(((0[1-9]|1[0-9]|2[0-8])[/](0[1-9]|1[012]))|((29|30|31)[/](0[13578]|1[02]))|((29|30)[/](0[4,6,9]|11)))[/](19|[2-9][0-9])\d\d$)|(^29[/]02[/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;

yup.addMethod(yup.string, 'date', function () {
  return this.test('date', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && dateRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid date' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'hour', function () {
  return this.test('hour', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && hourRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid hour' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'some', function (fieldClass) {
  return this.test('some', function () {
    const { createError, path } = this;
    const fields = [];
    for (const field of document.getElementsByClassName(fieldClass)) {
      const { name, checked } = field.firstChild;
      fields.push({ name, checked });
    }
    return new Promise((resolve, reject) => {
      const fieldAlreadyExists = fields.find(field => field.checked);
      if (!fieldAlreadyExists) {
        reject(
          createError({
            message: 'No items selected',
            path
          })
        );
      } else {
        resolve(true);
      }
    });
  });
});

yup.addMethod(yup.string, 'start', function () {
  return this.test('start', function () {
    const { path, createError } = this;
    const dateStart = new Date(
      document.getElementsByName('dateStart')[0].getAttribute('date')
    );
    const dateEnd = new Date(
      document.getElementsByName('dateEnd')[0].getAttribute('date')
    );
    const hourStart = document.getElementsByName('hourStart')[0].value;
    const hourEnd = document.getElementsByName('hourEnd')[0].value;

    return new Promise((resolve, reject) => {
      if (hourRegex.test(hourStart) && hourRegex.test(hourEnd)) {
        const start = hourStart.split(':').map(n => parseInt(n, 10));
        const end = hourEnd.split(':').map(n => parseInt(n, 10));
        dateStart.setHours(start[0], start[1], start[2]);
        dateEnd.setHours(end[0], end[1], end[2]);
        if (dateStart < dateEnd) {
          resolve(true);
        } else {
          reject(
            createError({
              message: 'Start smaller than the end',
              path
            })
          );
        }
      } else {
        resolve(true);
      }
    });
  });
});

yup.addMethod(yup.string, 'multiselect', function () {
  return this.test('multiselect', function () {
    const { path, createError } = this;
    const value = document.getElementsByClassName('multiselect-' + path)[0]
      .options.length;
    return new Promise((resolve, reject) => {
      if (value) {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

const schema = yup.object().shape({
  dateStart: yup
    .string()
    .date()
    .start(),
  hourStart: yup.string().hour(),
  dateEnd: yup.string().date(),
  hourEnd: yup.string().hour(),
  events: yup.string().some('event-fields')
});

export default schema;
